import StaticLink from './component'
export default StaticLink
